import React from 'react';
import PropTypes from 'prop-types';

const HeaderShadow = (props) => {
  const { children } = props;

  return <div className="header-shadow">{children}</div>;
};

HeaderShadow.propTypes = {
  children: PropTypes.node.isRequired,
};

export default HeaderShadow;
